/* eslint-disable react/jsx-no-bind */
import * as React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import urls from '../../constants/urls.js';
import Loading from '../common/Loading';
import * as discussionActions from '../../actions/discussionActions';
import ErrorMessage from '../common/ErrorMessage.js';

class DiscussionSectionPage extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.loadDiscussionSections = this.loadDiscussionSections.bind(this);
        this.state = {
            loading: false,
            loadingError: false
        };
    }

    componentWillMount() {
        if(!this.props.sections.length) {
            this.loadDiscussionSections();
        }        
    }

    componentDidUpdate(prevProps) {
    }

    loadDiscussionSections() {
        this.setState({ loading: true, loadingError: false });
        this.props.actions.getSections()        
            .then(_ => {
                this.setState({
                    loading: false,
                    loadingError: false
                });
            })
            .catch(error => {
                this.setState({ loading: false, loadingError: true });
            });
    }

    render() {
        return (
            <div className="main">
                <MetaTags>       
                    <title>Music Discussion Forums - LoudUp - Music Social Network</title>     
                    <meta id="description" name="description" content="Chat and discuss music related topics and connect with other fans, artists, producers and more. Talk about new music and the music industry, get advice, organise collaborations and promote your music." />   
                </MetaTags>
                <div className="container">
                    <div className="block-inner minimal-height">
                        <h1 className="section-alt">Discussions</h1>
                        <div className="row">
                            <div className="col-md-12">
                                <div>
                                    {
                                        this.props.sections.length ?
                                            <ul id="a" className="list-unstyled itemlist discussion">
                                                {
                                                    this.props.sections.map(section => 
                                                        <li key={section.ID}>
                                                            <Link to={`/Discussions/${section.Link}`}>
                                                                <div className="disc-icon">
                                                                    <svg className="icon icn-discussion">
                                                                        <use xlinkHref="#icn-discussion" />
                                                                    </svg>
                                                                </div>
                                                                <h3>{section.Name}</h3>
                                                                <p className="desc">{section.Description}</p>
                                                                <p className="discno"><strong>{section.DiscussionCount}</strong> DISCUSSSIONS</p>
                                                            </Link>
                                                        </li>
                                                    )
                                                }
                                            </ul>
                                            : 
                                            this.state.loading ? 
                                                <Loading /> 
                                                : 
                                                this.state.loadingError ?
                                                    <ErrorMessage error="Sorry, something went wrong! Unable to load discussions." />
                                                    : 
                                                    null
                                    }
                                    
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}

DiscussionSectionPage.propTypes = {
    sections: PropTypes.array,
    actions: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    return {
        sections: state.discussions.sections
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, discussionActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(DiscussionSectionPage);